var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5.08763,
    fill: "#D9BFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3066 18.3825C65.9909 17.6713 65.4676 17.0663 64.8019 16.6427C64.1362 16.2191 63.3575 15.9956 62.5626 16.0001H17.429C16.6348 16.0016 15.8582 16.2277 15.1934 16.6511C14.5285 17.0744 14.0039 17.6767 13.6833 18.385C13.3627 19.0932 13.2598 19.877 13.387 20.6411C13.5143 21.4053 13.8663 22.117 14.4004 22.6899L14.4209 22.7124L31.7896 40.792V59.9991C31.7895 60.7231 31.9908 61.4335 32.3723 62.0546C32.7537 62.6758 33.3009 63.1843 33.9555 63.5261C34.6101 63.8679 35.3476 64.0301 36.0894 63.9954C36.8311 63.9607 37.5493 63.7304 38.1673 63.3291L46.3734 57.9942C46.936 57.6289 47.3972 57.1338 47.7162 56.5529C48.0352 55.9719 48.202 55.3232 48.2019 54.6643V40.792L65.5732 22.7124L65.5937 22.6899C66.1334 22.1196 66.4888 21.4069 66.6156 20.6409C66.7424 19.8749 66.6349 19.0894 66.3066 18.3825ZM45.2118 38.0696C44.4991 38.806 44.1011 39.7796 44.0988 40.792V54.6643L35.8927 59.9991V40.792C35.8951 39.776 35.4987 38.7975 34.7849 38.0571L17.429 20H62.5626L45.2118 38.0696Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.96e11c3b62f8d22b308c5007a6ab9a30.svg";
export { ForwardRef as ReactComponent };